export default __webpack_public_path__ + "static/media/DSC09600.6417a429.JPG";